import { BrowserModule } from '@angular/platform-browser';
import { NgModule, InjectionToken, APP_INITIALIZER } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { HttpModule } from '@angular/http';
import {APP_BASE_HREF} from '@angular/common';

import { AppComponent } from './app.component';
import { routes, routesProvider } from './app.routes';

import { HttpApiService } from "app/services/http.api";

import { CreatorComponent} from './creator/creator.component';
import { CanvasComponent} from './creator/canvas/canvas.component';
import { CreatorModule  } from "./creator/creator.module";
import { MyAppSharedSettings, DNN_AppConfig, APP_CONFIG }  from './app.setting';
import { CommonModule } from '@angular/common';
import { FlexLayoutModule } from '@angular/flex-layout';
import { SplashComponent } from './splash/splash.component';
import { RubriquesComponent } from "./creator/rubriques/rubriques.component";
import { DiaporamaComponent } from './creator/diaporama/diaporama.component';
import { ModeleService } from "app/services/modele.service";
import { CookieService } from 'angular2-cookie/services/cookies.service';
import { SwiperModule, SwiperConfigInterface } from 'ngx-swiper-wrapper';
import { ConfigService } from "app/services/config.service";
import { Config } from "app/config/config";
import { AppMain } from './app.main';
import { Router } from '@angular/router';
import { ToReverseHtmlPipe } from 'app/pipes/toHtmlContent.pipe';

export function configServiceFactory (config: Config, configService: ConfigService) {
  return () => configService.load();
  //return function() { configService.load()};
}

export function configFactory (config: Config) {
  return () => config.load();
  //return function() { config.load()};
}
const SWIPER_CONFIG: SwiperConfigInterface = {
            
};

@NgModule({
  declarations: [
    ToReverseHtmlPipe,
    AppMain, AppComponent,CreatorComponent, CanvasComponent,
    SplashComponent, RubriquesComponent, DiaporamaComponent
],
  imports: [
    HttpModule,
    BrowserModule,
    FormsModule,
    CommonModule,
    FlexLayoutModule,
    SwiperModule.forRoot(SWIPER_CONFIG),
    routesProvider
  ],
  providers: [ 
    { provide: APP_CONFIG, useValue: DNN_AppConfig } ,
    { provide: APP_BASE_HREF, useValue : '/' },
    HttpApiService,
    ModeleService,
    CookieService,
    MyAppSharedSettings,
    Config,
     {
      provide: APP_INITIALIZER,
      useFactory: configFactory,
      deps: [Config],
      multi: true
    },
    ConfigService,
    {
      provide: APP_INITIALIZER,
      useFactory: configServiceFactory,
      deps: [Config, ConfigService],
      multi: true
    }
  ],
  bootstrap: [AppMain]
})
export class AppModule {
  constructor(private router:Router, private config:Config) {

    this.config.getData().subscribe((result) => {

      let newroutes = [];
      let newPath = result["baseRouterPath"];
      newroutes.push({ path: newPath, component:AppComponent });
      newroutes.push({ path:'**', redirectTo: newPath });
      
      router.resetConfig(newroutes);
    });
    // This works
    // Pushing the same route as in routes.json
    // ----------------------
    

    // // This does not work
    // // Loads json data from service and push the new route
    // // ----------------------
    // this.routerService.getRoutes().subscribe((result) => {
    //   result.forEach((route) => {
    //     routes.push({ path: route.path, loadChildren: route.loadChildren })
    //   });
    //   this.router.resetConfig(routes);
    // });

    // // This does works
    // // By just console log this anonymous object, the loaded routing from the 
    // // json data will work. 
    // // ----------------------
    // console.log({ loadChildren: './contact/contact.module#ContactModule' })
    // this.routerService.getRoutes().subscribe((result) => {
    //   result.forEach((route) => {
    //     routes.push({ path: route.path, loadChildren: route.loadChildren })
    //   });
    //   this.router.resetConfig(routes);
    // });
    }
  }



// WEBPACK FOOTER //
// ./src/app/app.module.ts